/* eslint-disable import/no-anonymous-default-export */
export default {
  "projectItem.name": "Nombre",
  "projectItem.version": "Revisión",
  "projectItem.owner": "Propietario",
  "projectItem.description": "Descripción",
  "projectItem.updated_at": "Fecha de Actualización",
  "projectItem.created_at": "Fecha",
  "projectItem.download": "Descargar",
  "projectItem.delete": "Eliminar",
  "projectItem.folderRoot": "Carpeta Raíz",
  "projectItem.new_folder": "Nueva Carpeta",
  "projectItem.upload": "Subir",
  "projectItem.add": "Agregar Archivo",
  "projectItem.update": "Actualizar",
  "projectItem.input.remove": "Eliminar",
  "projectItem.input.required": "Campo obligatorio",
  "projectItem.menuItem.Download": "Descargar",
  "projectItem.menuItem.share": "Compartir",
  "projectItem.menuItem.details": "Detalles",
  "projectItem.menuItem.view": "Visualizar",
  "projectItem.menuItem.personalize": "Personalizar",
  "projectItem.menuItem.personalize.folderColor": "Color de la carpeta",
  "projectItem.search": "Buscar",
  "projectItem.listFile": "Lista de Archivos",
  "projectItem.revision.place.extern": "Revisión externa",
  "projectItem.revision.numeric.help":
    "La revisión de los archivos debe seguir obligatoriamente el patrón R00, R01, R99.",
  "projectItem.revision.alphabetical.help":
    "La revisión de los archivos debe seguir obligatoriamente el patrón RA, RB, RCZ.",
  "projectItem.revision.doubleNumeric.help":
    "La revisión de los archivos debe seguir obligatoriamente el patrón R00.00, R01.01, R99.99.",
  "projectItem.validation.description": "Ingresa la descripción",
  "projectItem.validation.revision": "Ingresa la revisión",
  "projectItem.placeholder.description": "Descripción del contenido",
  "projectItem.placeholder.description.file": "Descripción del archivo",
  "projectItem.placeholder.description.folder": "Descripción de la carpeta",
  "projectItem.modal.send": "Enviar",
  "projectItem.modal.cancel": "Cancelar",
  "projectItem.modal.revisionInfo":
    "Al registrar un archivo con una nueva revisión, será reemplazado automáticamente",
  "projectItem.error": "Ocurrió algún error",
  "projectItem.upload.dropText": "Arrastra los archivos aquí",
  "projectItem.upload.dropHint": "O haz clic aquí y busca",
  "projectItem.pathTaken": "Ruta recorrida",
  "projectItem.drawerDetails.title": "Detalles",
  "projectItem.drawerDetails.folder": "Detalles de la carpeta",
  "projectItem.drawerDetails.folderName": "Nombre de la carpeta",
  "projectItem.drawerDetails.files": "Detalles del archivo",
  "projectItem.drawerDetails.fileName": "Nombre del archivo",
  "projectItem.drawerDetails.owner": "Propietario",
  "projectItem.drawerDetails.from": "Por",
  "projectItem.drawerDetails.modified": "Modificado en",
  "projectItem.drawerDetails.lastVersions": "Últimas versiones",
  "projectItem.drawerDetails.historic": "Historial",
  "projectItem.drawerDetails.ative": "Activo",
  "projectItem.drawerDetails.copy": "Copiado",
  "projectItem.drawerDetails.downloadLastVersion": "Descargar última versión",
  "projectItem.drawerDetails.download.withoutRevision":
    "La revisión no será incluida en el nombre del archivo usando esta descarga.",
  "projectItem.error.maxNameLength":
    "Nombre con tamaño por encima del límite de caracteres.",
  "projectItem.line1": "Gestiona tus proyectos con más",
  "projectItem.highlight1": "organización",
  "projectItem.and": "y",
  "projectItem.highlight2": "seguridad!",
  "projectItem.link": "Haz clic aquí",
  "projectItem.line3": "y tenlo en tu empresa también.",
  "projectItem.headerTagline":
    "¡Gestiona tus proyectos con más organización y seguridad!",
  "projectItem.ctaJoinplace": "Conoce Joinplace",
};
